const PenaltyEvent = ({ event, getPlayerName, getTeamAbbreviation }) => {
    const penalizedPlayerId = event.details?.committedByPlayerId;
    const penalizedPlayerName = getPlayerName(penalizedPlayerId);
    const penalizedPlayerTeamId = event.details?.eventOwnerTeamId;
    const penalizedPlayerTeamAbbrev = getTeamAbbreviation(penalizedPlayerTeamId);
    const penalizedPlayerMugshotUrl = penalizedPlayerId ? `https://assets.nhle.com/mugs/nhl/20242025/${penalizedPlayerTeamAbbrev}/${penalizedPlayerId}.png` : null;
    const penaltyDescription = event.details?.descKey || 'N/A';
    const penaltyDuration = event.details?.duration ? `${event.details.duration} min` : 'N/A';

    return (
        <div className="flex items-center mb-2">
            <span className="text-sm font-semibold text-gray-700 mr-2">Time:</span>
            <span className="text-sm text-gray-900 mr-2">{event.timeInPeriod}</span>
            <span className="text-sm font-semibold text-gray-700 mr-2">Period:</span>
            <span className="text-sm text-gray-900 mr-2">{event.periodDescriptor.number}</span>
            <span className="text-sm font-semibold text-gray-700 mr-2">{penalizedPlayerName}</span>
            {penalizedPlayerMugshotUrl && (
                <img
                    src={penalizedPlayerMugshotUrl}
                    alt={penalizedPlayerName}
                    className="inline-block ml-2 w-8 h-8 rounded-full"
                />
            )}
            <span className="text-sm font-semibold text-gray-700 mx-2">Penalty for</span>
            <span className="text-sm text-gray-900 mr-2">{penaltyDescription}</span>
            <span className="text-sm font-semibold text-gray-700 mx-2">Duration:</span>
            <span className="text-sm text-gray-900">{penaltyDuration}</span>
        </div>
    );
};

export default PenaltyEvent;